var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import { ButtonBase } from '../../buttons/ButtonBase';
export var ButtonSlim = styled(ButtonBase)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n\n  &:hover {\n    background: ", ";\n    opacity: 0.8;\n  }\n"], ["\n  background: ", ";\n\n  &:hover {\n    background: ", ";\n    opacity: 0.8;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.action;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.action;
});
var templateObject_1;
